/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getSupportContactStatus} from '../api'

 export const useQueryGetSupportContactStatus = createReactQueryHook('getSupportContactStatus', getSupportContactStatus)
